import { FC } from 'react'
import { Button, cn } from '@wellesley/ui'
import { ChevronRight } from 'lucide-react'

import ReportLayout from '../ReportLayout'

import { getReportOptions, REPORT_STEP } from './options'

type TReportList = {
  hasGroupRules: boolean
  onChange(v: REPORT_STEP): void
}

const ReportList: FC<TReportList> = ({ hasGroupRules, onChange }) => {
  const reportOptions = getReportOptions(hasGroupRules)

  return (
    <ReportLayout>
      <div className="gap-none mb-xs">
        {reportOptions.map((item) => (
          <label
            key={item.step}
            data-testid={`report-option-${item.step}`}
            onClick={() => {
              onChange(item.step)
            }}
            className={cn(
              'py-s flex w-full cursor-pointer flex-col border-t border-gray-200 text-gray-700',
              {
                'pt-none border-t-0': item.step === reportOptions.at(0)?.step,
                '!pb-0': item.step === 'another_problem',
              },
            )}
          >
            <div className="gap-xs flex items-center">
              <div className="size-m flex items-center justify-center rounded-full border border-gray-200">
                {item.icon}
              </div>
              <div className="gap-xxxs flex-col">
                <h3 className="text-base font-semibold text-gray-900">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-500">{item.description}</p>
              </div>

              <Button
                variant="none"
                size="none"
                data-testid="option-chevron"
                className="ml-auto"
              >
                <ChevronRight size={20} color="var(--gray-400)" />
              </Button>
            </div>
          </label>
        ))}
      </div>
    </ReportLayout>
  )
}

export default ReportList
